<div class="identity-banner" role="note">
  <div class="identity-banner__icon" aria-hidden="true">
    <img src="/public/svgs/identity-id.svg" alt="" width="18" height="18" />
  </div>

  <p class="identity-banner__text">
    @if (showGraceCountdown()) {
      {{ graceMessageKey() | translate: { days: graceDays() } }}
    } @else {
      {{ messageKey() | translate }}
    }
  </p>

  <button type="button" class="identity-banner__cta" (click)="startVerification()">
    {{ ctaKey() | translate }}
  </button>
</div>
